import { useTranslation } from 'react-i18next';
import MenuItem from '@mui/material/MenuItem';
import CustomSelect from '../UI/CustomSelect';
import { plausibilityCheckOptions } from '../CapacityReport/helpers/constants';

export type PlausibilityCheckSelectProps = {
    selectedValue: string;
    onChange: (selectedValue: string) => void;
};

function PlausibilityCheckSelect({ selectedValue, onChange }: PlausibilityCheckSelectProps) {
    const { t } = useTranslation();

    return (
        <CustomSelect
            selectedValue={selectedValue}
            options={plausibilityCheckOptions}
            onChange={onChange}
            label={t('plausibility.selectLabel')}
        >
            {plausibilityCheckOptions &&
                plausibilityCheckOptions.map(({ value, text }) => (
                    <MenuItem value={value} key={value}>
                        {t(text)}
                    </MenuItem>
                ))}
        </CustomSelect>
    );
}

export default PlausibilityCheckSelect;
